// This site's own source, as the build lays it out for the Zed window (scripts/zed-source.js):
// public/zed/tree.json, the project's folders and files, and public/zed/files/, the files Zed can
// show. Zed's editor and the terminals (utils/shell.js) read the project from here.

export const PROJECT = "federation-layout";
// Where the project sits in the shells' home folder.
export const PROJECT_CWD = ["Desktop", PROJECT];

export const fileUrl = (path) => `${process.env.PUBLIC_URL}/zed/files/${path}`;

let tree = null;
let treeLoading = null;

// The project tree, fetched once: { name, dir, children: [{ name, dir, ignored, children } or
// { name, size, binary }] }.
export const loadTree = () => {
  if (!treeLoading) {
    treeLoading = fetch(`${process.env.PUBLIC_URL}/zed/tree.json`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(r.status))))
      .then((t) => {
        tree = t;
        return t;
      })
      .catch((error) => {
        treeLoading = null;
        throw error;
      });
  }
  return treeLoading;
};

// The tree if it has arrived, for code that can't wait for it.
export const loadedTree = () => tree;

const texts = new Map();

// A file's text, fetched once.
export const readFile = (path) => {
  if (!texts.has(path)) {
    texts.set(
      path,
      fetch(fileUrl(path))
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(r.status))))
        .catch((error) => {
          texts.delete(path);
          throw error;
        }),
    );
  }
  return texts.get(path);
};

export const IMAGE = /\.(png|jpe?g|webp|gif|svg|ico)$/i;

// Opens a file of the project in Zed (opening Zed if it's closed).
export const openInZed = (path) => window.dispatchEvent(new CustomEvent("open-zed", { detail: { file: path } }));
